import React from 'react';
import { CmsFeature } from '../../types/contentstack';

interface CmsSignUpTodayData {
  name?: string;
  component?: string;
  features: CmsFeature[];
}

interface CmsSignUpTodayProps {
  data: CmsSignUpTodayData;
}

const CmsSignUpToday: React.FC<CmsSignUpTodayProps> = ({ data }) => {
  return (
    <section className="flex flex-col items-center gap-500 self-stretch bg-white py-800 px-500">
      {data.name && (
        <h2 className="text-center font-montserrat text-heading-200 font-bold leading-[112.5%] tracking-[-0.96px] text-[#34363B]">
          {data.name}
        </h2>
      )}
      <div className="flex justify-center gap-6 px-500 w-full">
        {data.features.map((feature) => (
          <div
            key={feature._metadata?.uid ?? feature.heading}
            className="flex flex-col items-center gap-200 flex-1"
          >
            {feature.image && (
              <div className="w-[120px] h-[120px] rounded-[16px] overflow-hidden flex-shrink-0">
                <img
                  src={feature.image.url}
                  alt={feature.heading}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <h3 className="text-center font-montserrat text-body-125 font-bold leading-[112.5%] tracking-[-0.3px] text-gray-925">
              {feature.heading}
            </h3>
            <div
              className="text-center font-montserrat text-body-100 font-medium leading-[162.5%] text-gray-925"
              dangerouslySetInnerHTML={{ __html: feature.body }}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default CmsSignUpToday;
